



















































































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import ScrollButton from "@/components/ScrollButton.vue";
import {LongTextWings} from '@/components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {AddressBookContactItem} from "@/store/addressbooks/types";
import ImportContacts from "@/components/AddressBooks/ImportContacts.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import AddressBookContactsFilter from "@/components/AddressBooks/AddressBookContactsFilter.vue";
import AddressBookContactActions from "@/components/AddressBooks/AddressBookContactActions.vue";

@Component({components: {AddressBookContactsFilter, AddressBookContactActions, ImportContacts, LongTextWings, ScrollButton}})
export default class AddressBookContacts extends BaseItemsPage<AddressBookContactItem>{
  @Getter("addressBookContacts") addressBookContactsResponse: any;
  @Action("getAddressBookContacts") actionGetAddressBookContacts: any;
  @Action("exportAddressBookContacts") actionExport: any;
  @Action("deleteAddressBookContacts") actionDelete: any;
  private is_show_filter = false;
  private is_show_import = false;
  private is_show_actions = false;
  private recipientIds:(number|undefined)[] = [];
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['id', 'msisdn', 'email', 'name', 'surname', 'middlename', 'additional'];

  getData(): any {
    return this.addressBookContactsResponse;
  }

  additionalFields(item: any) {
    let arr = []
    for (var i = 1; i <= 6; i++) {
      if (item['field'+i]) {
        arr.push(`№${i}: ` + item['field'+i])
      }
    }
    return arr.join('; ')
  }

  back(): void{
    this.$router.push('/address_book/group');
  }

  exportContacts(): void {
    try {
      this.actionExport(this.$route.params.id)
    } catch(error) {
      notifyError(error);
    }
  }

  onSelect(items:AddressBookContactItem[]):void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }

  onRefresh() {
    // @ts-ignore
    this.$refs.filter.filtered()
  }
}
